import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import missing_image from "i/missing_image.svg";

import {
  getMetricForColumn,
  sortNumeric,
  selectFormat,
  Error,
} from "./../../Utils/Utils.js";

function title(cell, row) {
  return (
    <span className="table-content-cell">
      <span className="table-content-cell__media">
        <img
          src={row.image_url ? row.image_url : missing_image}
          alt={row.title}
          className="table-content-cell__img"
        />
      </span>
      <span className="table-content-cell__link">
        <a href={row.url} target="_blank" rel="noopener noreferrer">
          {row.title}
        </a>
      </span>
    </span>
  );
}

class ContentTopPagesIntercept extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { title: _title, columns } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    let table_columns = [
      {
        dataField: "title",
        text: "Title",
        style: { width: "280px", minWidth: "280px", textAlign: "left" },
        headerAlign: "left",
        formatter: title,
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "url",
        text: "URL",
        hidden: true,
        sort: true,
      },
      {
        dataField: "categories",
        text: "Categories",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        sort: true,
      },
      {
        dataField: "content_id",
        text: "Content ID",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        sort: true,
      },
      {
        dataField: "entrances",
        text: "Entrances",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        sort: true,
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sortFunc: sortNumeric,
      },
      {
        dataField: "exits",
        text: "Exits",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        sort: true,
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sortFunc: sortNumeric,
      },

      {
        dataField: "new_users",
        text: "New Users",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        sort: true,
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sortFunc: sortNumeric,
      },
      {
        dataField: "sessions",
        text: "Sessions",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        sort: true,
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sortFunc: sortNumeric,
      },
      {
        dataField: "time_on_page",
        text: "Time on Page",
        style: { width: "110px", minWidth: "110px", textAlign: "left" },
        sort: true,
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sortFunc: sortNumeric,
      },
      {
        dataField: "verticals",
        text: "Verticals",
        style: { width: "100px", minWidth: "100px", textAlign: "left" },
        sort: true,
      },
      {
        dataField: "authors",
        text: "Author(s)",
        style: { width: "110px", minWidth: "120px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "subjects",
        text: "Tags",
        style: { width: "110px", minWidth: "110px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "tags",
        text: "Tags",
        style: { width: "110px", minWidth: "110px", textAlign: "left" },
        headerAlign: "left",
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "published_date",
        text: "Publish Date",
        style: { width: "110px", minWidth: "110px" },
        formatter: (cell, row) => selectFormat("date", cell),
        csvFormatter: (cell) => {
          if (cell) {
            return selectFormat("date", cell);
          }
        },
        sort: true,
        sortFunc: (a, b, order) =>
          order === "desc" ? (a > b ? 1 : -1) : b > a ? 1 : -1,
      },
      {
        dataField: "page_views",
        text: "Page Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "views",
        text: "Views",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "subscribes",
        text: "Newsletter Signups",
        style: { width: "150px", minWidth: "150px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "orders",
        text: "New Orders",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "first_time_donors",
        text: "First Time Donors",
        style: { width: "130px", minWidth: "130px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "total_dollars",
        text: "Total Dollars",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "new_visitors",
        text: "New Visitors",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "reactions",
        text: "Reactions",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "shares",
        text: "Shares",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "visits",
        text: "Visits",
        style: { width: "80px", minWidth: "80px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "total_transactions",
        text: "Total Transactions",
        style: { width: "110px", minWidth: "110px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
    ];

    const defaultSorted = [
      {
        dataField: "page_views",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (columns && columns.length) {
      selected_columns = [];
      columns.forEach((cell, i) => {
        selected_columns.push(table_columns.find((o) => o.dataField === cell));
      });
    }

    const paginate = paginationFactory({
      sizePerPage: 25,
      hideSizePerPage: true,
    });

    const filename = _title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            filter={filterFactory()}
            defaultSorted={defaultSorted}
            pagination={paginate}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return this.renderTable(data.data);
  }
}

export default ContentTopPagesIntercept;
